/** Phase 8 (Finanzen und Analysen) — Fehlermeldungen und Berechtigungsnamen, Deutsch (ADR-801). */
export const faz8ErrorsDe = {
  shipment_cost_exists:
    'Für diese Sendung sind bereits Versandkosten erfasst; bearbeiten Sie den vorhandenen Eintrag.',
  vat_exceeds_amount: 'Die MwSt. darf den Gesamtbetrag nicht übersteigen.',
  tracking_not_found: 'Keine Sendung mit dieser Sendungsnummer.',
  tracking_ambiguous:
    'Diese Sendungsnummer gehört zu mehreren Sendungen; erfassen Sie die Kosten direkt an der Sendung.',
  duplicate_in_file: 'Diese Sendungsnummer kommt in der Datei mehrfach vor.',
  amount_required: 'Der Betrag ist leer oder nicht lesbar.',
  date_unreadable: 'Datum nicht lesbar (TT.MM.JJJJ oder JJJJ-MM-TT).',
  cost_file_columns_missing:
    'Die Datei enthält keine Spalten „Takip no“ (Sendungsnummer) und „Tutar“ (Betrag).',
  supplier_code_exists: 'Ein Lieferant mit diesem Code existiert bereits.',
  supplier_inactive: 'Der Lieferant ist inaktiv; aktivieren Sie ihn zuerst.',
  purchase_order_not_editable:
    'Nach dem Bestellen können Positionen, Lager und Währung nicht mehr geändert werden; nur das erwartete Datum und die Notiz.',
  purchase_order_status: 'Diese Aktion ist im aktuellen Status der Bestellung nicht möglich.',
  purchase_order_not_receivable:
    'Wareneingang ist nur für bestellte und noch nicht vollständig eingegangene Bestellungen möglich.',
  warehouse_inactive: 'Das Lager ist inaktiv; aktivieren Sie es für den Wareneingang.',
  duplicate_variant:
    'Dasselbe Produkt darf nicht in mehreren Positionen stehen; geben Sie die Menge in einer Position ein.',
  over_receipt:
    'Die Eingangsmenge übersteigt die offene Menge; aktivieren Sie die Option, um eine Überlieferung anzunehmen.',
  duplicate_line: 'Dieselbe Bestellposition darf in einem Wareneingang nicht zweimal vorkommen.',
  lot_expiry_mismatch: 'Diese Chargennummer ist mit einem anderen Mindesthaltbarkeitsdatum erfasst.',
  supplier_entry_not_reversible:
    'Eine Wareneingangsrechnung kann nicht storniert werden; gleichen Sie die Differenz mit einer Korrektur aus. Eine Gegenbuchung kann nicht storniert werden.',
  report_metric_invalid: 'Diese Kennzahl ist im gewählten Datenbestand nicht verfügbar.',
  report_dimension_invalid: 'Diese Dimension ist im gewählten Datenbestand nicht verfügbar.',
  report_duplicate: 'Dieselbe Kennzahl oder Dimension kann nicht zweimal gewählt werden.',
  report_pivot_one_metric: 'Mit einer Spaltendimension (Pivot) wählen Sie genau eine Kennzahl.',
  report_filter_invalid: 'Dieser Filter kann mit dem gewählten Datenbestand nicht verwendet werden.',
  report_definition_invalid: 'Die Berichtsdefinition konnte nicht gelesen werden.',
  dashboard_widget_limit: 'Sie können der Übersicht bis zu {{max}} Widgets hinzufügen.',
  dashboard_widget_exists: 'Dieser Bericht ist bereits in Ihrer Übersicht.',
  widget_order_mismatch: 'Die Reihenfolge muss jedes Widget genau einmal enthalten.',
  report_export_not_ready: 'Die Datei ist noch nicht fertig oder konnte nicht erstellt werden.',
  report_export_too_large:
    'Die Datei überschreitet die Grenze von 20 MB; fügen Sie einen Filter hinzu oder verringern Sie die Zeilendimensionen.',
  report_member_inactive: 'Die Mitgliedschaft des Benutzers ist nicht aktiv; es wurde keine Datei erstellt.',
  no_eligible_recipient: 'Kein Empfänger darf diesen Bericht sehen; es wurde keine E-Mail gesendet.',
  payment_not_disputable:
    'Eine Rückbuchung kann nur für eine vereinnahmte Kartenzahlung (iyzico, PayTR) oder eine physische POS-Zahlung erfasst werden.',
  dispute_exceeds_payment: 'Der strittige Betrag übersteigt den nicht strittigen Betrag der Zahlung.',
  dispute_fee_too_large: 'Die Rückbuchungsgebühr darf den Zahlungsbetrag nicht übersteigen.',
  dispute_case_exists: 'Für diese Zahlung gibt es bereits eine Rückbuchung mit dieser Fallnummer.',
  dispute_status_transition: 'Die Rückbuchung kann nicht von ihrem aktuellen Status in diesen wechseln.',
  date_before_opened: 'Dieses Datum darf nicht vor der Eröffnung der Rückbuchung liegen.',
  date_after_closed: 'Das Eröffnungsdatum darf nicht nach dem Abschlussdatum liegen.',
  simulation_currency_unsupported: 'Die Preissimulation unterstützt derzeit nur Preislisten in TRY.',
  workflow_field_invalid: 'Dieses Feld gibt es für den gewählten Auslöser nicht.',
  workflow_operator_invalid: 'Dieser Vergleich kann mit diesem Feld nicht verwendet werden.',
  workflow_value_invalid:
    'Der Wert passt nicht zu diesem Feld (erwartet wird eine Zahl, eine Option oder ein Text).',
  workflow_actions_required: 'Fügen Sie mindestens eine Aktion hinzu.',
  workflow_action_incompatible: 'Diese Aktion kann mit dem gewählten Auslöser nicht verwendet werden.',
  workflow_recipient_invalid: 'Einer der Empfänger ist kein aktives Mitglied des Unternehmens.',
  saved_report_not_found: 'Der gespeicherte Bericht wurde nicht gefunden oder Sie dürfen ihn nicht sehen.',
  workflow_template_linked:
    'Dieses Beispiel sendet Nachrichten an Kunden; es wird wegen der Einwilligungs- und İYS-Prüfung im eigenen Bereich verwaltet.',
  workflow_archived: 'Ein archivierter Ablauf kann nicht geändert oder eingeschaltet werden.',
  workflow_active: 'Ein eingeschalteter Ablauf kann nicht archiviert werden; halten Sie ihn zuerst an.',
  workflow_run_not_retryable: 'Nur ein fehlgeschlagener Lauf kann wiederholt werden.',
  workflow_not_active: 'Der Ablauf ist nicht eingeschaltet; schalten Sie ihn vor dem Wiederholen ein.',
  workflow_run_not_cancellable: 'Nur ein ausstehender Lauf kann abgebrochen werden.',
  workflow_subject_missing: 'Das Ereignis enthält keinen Datensatz, den diese Aktion benötigt.',
  owner_inactive: 'Die Mitgliedschaft der Person, die den Ablauf eingeschaltet hat, ist nicht aktiv.',
  no_recipient: 'Mit dieser Einstellung gibt es kein aktives Mitglied, an das eine E-Mail gehen kann.',
  seo_issues: 'Es gibt SEO-Probleme.',
  order_not_paid: 'Die Bestellung ist nicht im Status „Bezahlt“; sie wurde nicht geändert.',
  order_not_found: 'Bestellung nicht gefunden.',
  product_not_found: 'Produkt nicht gefunden.',
  post_not_found: 'Artikel nicht gefunden.',
  already_published: 'Die freigegebene Fassung ist bereits veröffentlicht.',
  invoice_uncertain:
    'Das Ergebnis der Rechnung ist unklar; prüfen Sie es in BizimHesap und markieren Sie es auf der Seite Rechnungen.',
  invoice_send_failed:
    'Die Rechnung konnte nicht an BizimHesap gesendet werden; senden Sie sie auf der Seite Rechnungen erneut.',
  workflow_paused: 'Der Ablauf wurde angehalten; der ausstehende Lauf wurde abgebrochen.',
  manual_retry: 'Der Lauf wurde manuell wiederholt.',
  too_short: 'Der Text ist zu kurz.',
  invalid: 'Ungültiger Wert.',
};

export const faz8PermissionsDe = {
  'reports.finance.manage':
    'Finanzeingaben verwalten (Zahlungsgebührenregeln, Versandkosten, Betriebsausgaben)',
  'purchasing.read': 'Lieferanten und Einkauf ansehen (inkl. Kosten und Lieferantensalden)',
  'purchasing.manage': 'Lieferanten und Bestellscheine verwalten',
  'purchasing.receive': 'Wareneingang (Bestandszugang zu Bestellscheinen)',
  'purchasing.ledger.manage':
    'Buchungen im Lieferantenkonto (Zahlungen, Rücksendungen, Eröffnung, Korrekturen)',
  'reports.custom.read':
    'Eigene Berichte ausführen und geteilte ansehen (Daten im Rahmen der eigenen Berechtigungen)',
  'reports.custom.manage': 'Eigene Berichte speichern und teilen',
  'reports.schedule.manage': 'Geplante Berichte (Download-Links per E-Mail an Mitglieder des Unternehmens)',
  'payments.dispute.manage': 'Rückbuchungen (Chargebacks): Erfassung, Status, Notizen und Dokumente',
  'workflows.read': 'Automatisierungsabläufe und ihr Laufprotokoll ansehen',
  'workflows.manage':
    'Automatisierungsabläufe erstellen, ein-/ausschalten und wiederholen (Aktionen laufen mit den Berechtigungen der einschaltenden Person)',
};
